import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { goBack } from "../../../services/utils/utility";

@Component({
  selector: "app-gdo-base",
  templateUrl: "./gdo-base.component.html",
  styleUrls: ["./gdo-base.component.css"]
})
export class GdoBaseComponent implements OnInit {
  constructor(private location: Location) {}
  goBack = goBack;

  ngOnInit() {}
}
